import React, { useState} from 'react';
import {
  Container,
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box, 
  Card,
  CardContent,Paper,Divider,
  CardMedia,
  IconButton,
  Stack,
} from "@mui/material";
import img6 from './img/img6.jpeg';
import {
  School as SchoolIcon,
  BusinessCenter as BusinessCenterIcon,
  TravelExplore as TravelExploreIcon,
  OnlinePrediction as OnlinePredictionIcon,
  People as PeopleIcon,
  ExitToApp as ExitToAppIcon,
} from '@mui/icons-material';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'; // For Consultant
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import BookIcon from '@mui/icons-material/Book'; // For Courses
import Footer from './Webfoot'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import Webhead from "../website/Webhead";
import img1 from "./img/img1.jpeg"; // Correctly importing image
import team1 from './img/team-1.jpg';
import team2 from './img/team-2.jpg';
import team3 from './img/team-3.jpg';
import qq from './img/qq.jpeg'

const AboutUs = () => {

  const services = [
    {
      title: 'Consultant',
      description: 'Education Consultant to individuals and Organizations',
      icon: <AssignmentIndIcon />,
    },
    {
      title: 'Migration',
      description: 'Migration services (student visa and resident) to Australia, Canada, USA and Europe',
      icon: <TransferWithinAStationIcon />,
    },
    {
      title: 'Management',
      description: 'Management Training Programmes, Education Tour packages',
      icon: <SchoolIcon />,
    },
    {
      title: 'Courses',
      description: 'Online/Distance learning Programmes from international universities',
      icon: <BookIcon />,
    },
  ];
  
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionChange = (index) => (event, isExpanded) => {
    setActiveIndex(isExpanded ? index : null);
  };

  const Products = [
    {
      title: 'Education Consultancy',
      icon: <SchoolIcon fontSize="large" />,
      description: 'Consulting services for individuals and organizations to improve educational outcomes.',
    },
    {
      title: 'University Representation',
      icon: <PeopleIcon fontSize="large" />,
      description: 'Representation of reputable universities from Australia, UK, USA, and Europe.',
    },
    {
      title: 'Management Training',
      icon: <BusinessCenterIcon fontSize="large" />,
      description: 'Tailored management training programmes and education tour packages.',
    },
    {
      title: 'Online Learning',
      icon: <OnlinePredictionIcon fontSize="large" />,
      description: 'Access to online/distance learning programmes from international universities.',
    },
    {
      title: 'European Global School Partner',
      icon: <TravelExploreIcon fontSize="large" />,
      description: 'Official partner to the European Global School, France.',
    },
    {
      title: 'Migration Services',
      icon: <ExitToAppIcon fontSize="large" />,
      description: 'Student visa and residency services to Australia, Canada, USA, and Europe.',
    },
  ];

  
  return (
    <Box>
      {/* Page Header */}
      <Box
      sx={{
        backgroundImage: `url(${qq})`, // Uncomment if you are using import
        // backgroundImage: `url('E:/Desktop/Lider Projects/trent/Trent Internation College/Trent- Frontend/copy/src/website/img/qq.jpeg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        py: 8,
        textAlign: 'center',
        color: 'white',
      }}
    >
      <Typography variant="h2" color="white" sx={{ fontWeight: 700 }}>
        About Us
      </Typography>
    </Box>

      {/* Why Choose Us Section */}
      <Container maxWidth="xl" sx={{ py: 6 }}>
      <Grid container spacing={5}>
        <Grid item lg={6}>
          <Typography variant="h5" color="primary" fontWeight={600} gutterBottom>
            Why Choose Us!
          </Typography>
          <Typography variant="h4" fontWeight={600} gutterBottom>
            Our Services
          </Typography>
          <Typography paragraph>
            AEG International College (TII) is established to bring education to your
            doorstep and enhance your profile with personnel and professional development.
          </Typography>
          <Grid container spacing={4}>
            {services.map((item, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Paper
                  elevation={3}
                  sx={{
                    p: 3,
                    display: 'flex',
                    alignItems: 'center',
                    height: '150px', // Fixed height for all cards
                    transition: 'transform 0.3s',
                    '&:hover': {
                      transform: 'scale(1.05)', // Scale on hover
                    },
                  }}
                >
                  <Box
                    sx={{
                      bgcolor: 'primary.main',
                      color: 'white',
                      p: 2,
                      borderRadius: '50%',
                      mr: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 56,
                      height: 56,
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Box>
                    <Typography variant="h6" fontWeight={600}>
                      {item.title}
                    </Typography>
                    <Typography variant="body2">{item.description}</Typography>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item lg={6}>
          <Box sx={{ position: 'relative', overflow: 'hidden', height: '400px' }}>
            <img
              src={img6}
              alt="Main visual"
              style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover' }}
            />
            <img
              src={img1}
              alt="Overlay visual"
              style={{ position: 'absolute', top: 0, right: 0, width: '200px', height: '200px' }}
            />
          </Box>
        </Grid>
      </Grid>

    </Container>

      {/* Accordion Section - Our Services */}


    <Container sx={{ py: 8 }}>
  {/* <Box textAlign="center" mb={6}>
    <Typography 
      variant="h4" 
      color="primary" 
      gutterBottom 
      sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}
    >
      Our Services
    </Typography>
    <Typography 
      variant="h2" 
      gutterBottom 
      sx={{ fontSize: { xs: "1.8rem", md: "2rem" }, fontWeight: 600 }}
    >
      Explore the Wide Range of Services We Offer
    </Typography>
    <Typography variant="body1" sx={{ color: "text.secondary", maxWidth: 600, mx: "auto" }}>
      We provide professional and educational services to help you excel, including language courses, vocational training, and migration support.
    </Typography>
  </Box> */}

  {/* Accordion Section */}
  {/* <Grid container spacing={3} justifyContent="center">
    {[
      { 
        title: "English Courses", 
        content: ["IELTS Intensive preparation", "Pearson Test English", "General English"] 
      },
      {
        title: "Trans Disciplinary Studies",
        content: [
          "Transformative learning",
          "Re-Balancing of ECO-System",
          "Transformative wellness",
          "Sustainable practice in day-to-day life",
        ],
      },
      { 
        title: "Vocational Courses", 
        content: ["International Trade", "Leadership and Management", "Early Childhood Education and Care"] 
      },
      { 
        title: "Diploma Courses", 
        content: ["Civil Engineering", "Mechanical Engineering", "Electrical Engineering", "Facilities Management"] 
      },
      { 
        title: "Degree Courses", 
        content: ["Civil Engineering", "Business", "Mechanical Engineering"] 
      },
    ].map((item, index) => (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <Accordion sx={{ boxShadow: 2, borderRadius: 2, overflow: "hidden" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "primary.main" }} />}
            sx={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}
          >
            <Typography variant="h6">{item.title}</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "white" }}>
            <ul style={{ paddingLeft: 20 }}>
              {item.content.map((point, idx) => (
                <li key={idx} style={{ marginBottom: 8, color: "text.secondary" }}>
                  {point}
                </li>
              ))}
            </ul>
          </AccordionDetails>
        </Accordion>
      </Grid>
    ))}
  </Grid> */}


    <Container sx={{ my: 8 }}>
      <Typography variant="h3" component="h4" sx={{ mb: 4, textAlign: 'center', fontWeight: 'bold' }}>
        Our Products and Services
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, textAlign: 'center', fontSize: '1.1rem', color: 'black' }}>
        AEG International College (TII) is established to bring education to your doorstep and enhance your profile with personnel and professional development.
      </Typography>
      <Grid container spacing={4}>
        {Products.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: '100%', // Ensures all cards are the same height
                backgroundColor: '#FCD018', // Set the background color
                color: 'black', // Set text color for contrast
                boxShadow: 3,
                textAlign: 'center',
                borderRadius: 2,
                transition: 'transform 0.3s', // Smooth transition for hover effect
                '&:hover': {
                  transform: 'scale(1.05)', // Scale effect on hover
                  boxShadow: 6, // Increased shadow on hover
                },
              }}>
              <CardContent sx={{ padding: 4 }}>
                <Box sx={{ mb: 2 }}>
                  {service.icon}
                </Box>
                <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
                  {service.title}
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Typography variant="body2" color="textSecondary">
                  {service.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>



  {/* Accordion Section */}
 
</Container> 


      {/* Team Section */}
      <Container sx={{ py: 8 }}>
        <Typography variant="h4" color="primary" gutterBottom>
          Meet The Team
        </Typography>
        <Typography variant="h2" sx={{ fontSize: "2rem", mb: 4 }}>
          We Have Great Coaching Experience
        </Typography>

        <Grid container spacing={4}>
          {[
            { name: "Sai Krishnan", title: "Trainer", img: team1 },
            { name: "Marry John", title: "Assistant Professor", img: team2 },
            { name: "Lucas Jack", title: "Trainer", img: team3 },
            { name: "David Bruce", title: "Trainer", img: team1 }, // Reusing the same image
          ].map((member, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card sx={{ boxShadow: 3 }}>
                <CardMedia component="img" height="300" image={member.img} alt={member.name} />
                <CardContent sx={{ textAlign: "center" }}>
                  <Typography variant="h5">{member.name}</Typography>
                  <Typography>{member.title}</Typography>
                  <Stack direction="row" justifyContent="center" spacing={1} mt={1}>
                    <IconButton>
                      <FacebookIcon />
                    </IconButton>
                    <IconButton>
                      <TwitterIcon />
                    </IconButton>
                    <IconButton>
                      <InstagramIcon />
                    </IconButton>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

const Check = () => {
  return (
    <div>
      <Webhead />
      <AboutUs />
      <Footer />
    </div>
  );
};

export default Check;
